//Base URL

const base_url = 'https://api.rawg.io/api/';
const key = 'ee55b384b4474a48a375d1bc5b8244e0';
const key_url = `key=${key}`;

//Get the date
const getCurrentMonth = () => {
	const month = new Date().getMonth() + 1;
	if (month < 10) {
		return `0${month}`;
	} else {
		return month;
	}
};

const getCurrentDay = () => {
	const day = new Date().getDate();
	if (day < 10) {
		return `0${day}`;
	} else {
		return day;
	}
};

//Current day/month/year
const currentYear = new Date().getFullYear();
const currentMonth = getCurrentMonth();
const currentDay = getCurrentDay();
const currentDate = `${currentYear}-${currentMonth}-${currentDay}`;
const last_year = `${currentYear - 1}-${currentMonth}-${currentDay}`;
const next_year = `${currentYear + 1}-${currentMonth}-${currentDay}`;

//Popular Games
const popular_games = `games?${key_url}&dates=${last_year},${currentDate}&ordering=-rating&page_size=10`;
const upcoming_games = `games?${key_url}&dates=${currentDate},${next_year}&ordering=-added&page_size=10`;
const new_games = `games?${key_url}&dates=${last_year},${currentDate}&ordering=-released&page_size=10`;

export const popularGamesURL = () => `${base_url}${popular_games}`;
export const upcomingGamesURL = () => `${base_url}${upcoming_games}`;
export const newGamesURL = () => `${base_url}${new_games}`;
export const gameDetailsURL = (game_id) =>
	`${base_url}games/${game_id}.json?&${key_url}`;
//Searched game
export const searchGameURL = (game_name) =>
	`${base_url}games?search=${game_name}&page_size=9`;
